var map = {
	"./addliquidity.json": 1068,
	"./box.json": 1069,
	"./components.json": 1070,
	"./constants.json": 1071,
	"./error.json": 1072,
	"./farm.json": 1073,
	"./home.json": 1074,
	"./launchpad.json": 1075,
	"./menu.json": 1076,
	"./minning.json": 1077,
	"./nft.json": 1078,
	"./pool.json": 1079,
	"./referral.json": 1080,
	"./removeliquidity.json": 1081,
	"./rolling.json": 1082,
	"./swap.json": 1083,
	"./team.json": 1084,
	"./uikit.json": 1085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1067;